import { PositiveEmotions } from "../../../SubjectData/BasicWords/Emotions.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function PositiveEmotionsDeck() {


 return (
    <>
      <HeaderNav GoBack_to="/EmotionsNav" />
      <FlashcardInterface deckData={PositiveEmotions} title="Positive Emotions" />
    </>
)}